import { resizeGame } from '@pascal/pascal-core';

const maxHeight = 700;
const maxWidth = 1196;
const target = document.querySelector('#root');

export const resizeGameHandler = () => {
  resizeGame(maxHeight, maxWidth, target, false);
};

export const resizeGameRange = (returnScaleValue = false) => {
  let scale;
  let wWidth;
  let wHeight;

  wWidth = window.innerWidth;
  wHeight = window.innerHeight;
  const widthToHeight = maxWidth / maxHeight;
  const wWidthToHeight = wWidth / wHeight;

  if (wWidthToHeight > widthToHeight) {
    wWidth = wHeight * widthToHeight;
    scale = wWidth / maxWidth;
  } else {
    wHeight = wWidth / widthToHeight;
    scale = wHeight / maxHeight;
  }

  if (returnScaleValue) {
    return scale;
  }
};
